import http from "@/axios/http-common";

async function createNote(rm: string | number, params): Promise<any> {
  const { data } = await http
    .postData(`/pasien/${rm}/note`, params)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function updateNote(
  rm: string | number,
  id: number,
  params
): Promise<any> {
  const { data } = await http
    .putData(`/pasien/${rm}/note/${id}`, params)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function deleteNote(rm: string | number, id: number): Promise<any> {
  const { data } = await http
    .deleteData(`/pasien/${rm}/note/${id}`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function getMultiPasienNote(rm: Array<string>): Promise<any> {
  const { data } = await http
    .getDataParam(`/pasien-note`, {
      params: {
        rm: rm.join(",")
      }
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function getNote(rm: string | number): Promise<any> {
  const { data } = await http.getData(`/pasien/${rm}/note`).catch(err => {
    return Promise.reject(err);
  });

  return data;
}

export default {
  createNote,
  updateNote,
  deleteNote,
  getMultiPasienNote,
  getNote
};
